import { Pipe, PipeTransform, inject } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Pipe({
    name: 'safeResourceUrl'
})
export class SafeUrlPipe implements PipeTransform {
	private readonly sanitizer = inject(DomSanitizer);

	public transform(url: string): SafeResourceUrl {
		return this.sanitizer.bypassSecurityTrustResourceUrl(url);
	}
}
